import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import AchraImagotipo from '@/modules/shared/components/svgs/achra-imagotipo.svg';
import AchraLogo from '@/modules/shared/components/svgs/achra-logo.svg';
export interface BrandAreaProps {
  children: React.ReactNode;
}

/**
 * Container for brand elements (left side of navbar)
 */
function BrandArea(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div className="flex items-center gap-4 sm:gap-9 xl:gap-4">{children}</div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
BrandArea.displayName = 'NavbarBrandArea';

/**
 * Achra brand logo (icon on mobile, imagotype on desktop)
 */
function AchraBrand() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="text-border flex items-center justify-center overflow-hidden py-4.5 pl-6" data-brand="achra"><Link href="/" target="_self" className="cursor-pointer" aria-label="Achra homepage"><AchraLogo className="text-primary h-9 w-9 sm:hidden" /><AchraImagotipo className="text-primary [&_path[data-type='text']]:fill-foreground hidden h-9 w-42 sm:flex" /></Link></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
AchraBrand.displayName = 'NavbarAchraBrand';
export { BrandArea, AchraBrand };